const locale = {
	configuratorTitle: 'Varialis Configuratore',
	popular: 'Più popolari',
	searchResults: 'Risultati della ricerca',
	price: 'Prezzo',
	amount: 'Valore',
	model: 'Modello',
	name: 'Nome',
	url: 'Url',
	company: 'Società',
	save: 'Salva',
	filterTypeName: 'Tipo',
	filterGroupName: 'Stile',
	filtersClear: 'Cancella filtri',
	filters: 'Filtri',
	searchPlaceholder: 'Cerca...',
	configurationStep1: 'Selezione modello',
	configurationStep2: 'Configurazione modello',
	configurationStep3: 'Panoramica configurazione',
	configurationStepCustomerView: 'Panoramica documenti',
	select: 'Seleziona',
	quantity: 'Quantità',
	overview: 'Panoramica',
	version: 'Versione',
	modelAndConfig: 'Modello / ID Config.',
	status: 'Stato',
	noResults: 'Nessun risultato',
	noData: 'Nessun dato',
	next: 'Avanti',
	prev: 'Indietro',
	nextPage: 'Pagina successiva',
	sendInquiry: 'Invia richiesta',
	step: 'Passaggio',
	of: 'di',
	comment: 'Commento',
	documentComment: 'Commento documento',
	documentCommentRemove: 'Rimuovi commento documento',
	clearConfiguration: 'Reimposta configurazione',
	cancel: 'Annulla',
	continue: 'Continua',
	close: 'Chiudi',
	exception: 'Eccezione',
	generalException: 'Ops! Qualcosa è andato storto.',
	apiException: 'Risposta errata dal server',
	myProjects: 'I miei progetti',
	allProjects: 'Tutti i progetti',
	assignDocument: 'Assegna (internamente)',
	assignDocumentWithinCompany: 'Assegna all’interno della società',
	assignDocumentOutsideCompany: 'Assegna al di fuori della società',
	assignDocumentToContactTitle: 'Contatto',
	assignDocumentToContactAddNew: 'Aggiungi nuovo contatto',
	assignDocumentToContactConfirmation: 'Sei sicuro di voler cambiare il contatto?',
	sendDocument: 'Invia al partner',
	toggleProjectStatus: 'Progetto',
	unknownUser: 'Sconosciuto',
	saveConfiguration: 'Aggiungi al carrello',
	saveConfigurationToDocument: 'Salva nel documento',
	addConfigurationToDocument: 'Aggiungi al documento',
	customerNewOffer: 'Crea documento',
	customerProcess: 'Processa',
	customerSendERP: 'Esporta in ERP',
	customerImportEdi: 'Importa da ERP',
	customerNewVersion: 'Imposta valore predefinito',
	customerAssign: 'Assegna alla persona',
	customerConfirmOrder: 'Conferma ordine',
	customerConfirmOrderMessage:
		'Con questa conferma, l’ordine (documento n. {number}) è rilasciato per la produzione. Con la conferma accetto le relative obbligazioni finanziarie (obbligo di pagamento).',
	customerConfirmInqury: 'Conferma richiesta',
	customerConfirmInquryNewProject: 'Crea in nuovo progetto',
	customerSendToConfirm: 'Invia per conferma',
	customerSend: 'Invia',
	customerForward: 'Inoltra',
	customerSendToSupplier: 'Invia al fornitore',
	customerSendOffer: 'Invia documento',
	customerSendOfferMissingEmail: 'Dokumenta ni mogoče poslati. E-naslov manjka.',
	customerSendDocument: 'Invia documento',
	customerDelete: 'Elimina',
	customerDeleteConfirm: 'Sei sicuro di voler eliminare il record selezionato?',
	configurator: 'Configuratore',
	configuratorPublic: 'Documentazione del prodotto',
	open: 'Apri',
	customerEditingTitleInquiry: 'Modifica richiesta',
	customerEditingTitleOffer: 'Modifica offerta',
	documentEditing: 'Modifica documento',
	configurationEditing: 'Modifica configurazione',
	adminCalculationDiscounts: 'Sconti',
	adminCalculationAddDiscount: 'Aggiungi sconto',
	adminCalculationAdditional: 'Accessori',
	adminCalculationCostsNet: 'Servizi',
	adminCalculationAdditionalCosts: 'Costo accessori',
	adminCalculationAddAdditionalCost: 'Aggiungi accessorio',
	adminCalculationAddNetCost: 'Aggiungi servizio',
	adminCalculationConfigurationPrice: 'Prezzo configurazione',
	adminCalculationAdditionalSum: 'Totale costo accessori',
	adminCalculationConfigurationWithAdditionalSum: 'Prezzo configurazione incl. accessori',
	adminCalculationDiscountPercentageSum: 'Totale percentuale sconto',
	adminCalculationDiscountSum: 'Totale valore sconto',
	adminCalculationConfigurationWithDiscountSum: 'Prezzo configurazione incl. accessori e sconti',
	adminCalculationServiceSum: 'Totale costo servizi',
	adminCalculationSum: 'Valore',
	adminRemark: 'Nota',
	adminRemarkAttachment: 'Allegato selezionato:',
	adminRemarkAddAttachment: 'Aggiungi allegato',
	adminRemarkAddAttachmentError: 'Questo tipo di allegato non è consentito.',
	adminDocumentationAdd: 'Carica allegato',
	adminDocumentationAddUrl: 'Aggiungi link',
	adminDocumentCustomer: 'Cliente',
	adminDocumentContact: 'Contatto',
	adminDocumentPartner: 'Partner responsabile',
	adminDocumentPartnerRecipient: 'Partner',
	adminDocumentDateModified: 'Data ultima modifica',
	adminDocumentStatus: 'Stato',
	adminDocumentDocumentNumber: 'Numero documento',
	adminDocumentProject: 'Progetto',
	adminDocumentProjectStatus: 'Stato progetto',
	adminDocumentDocumentOrder: 'Numero ordine documento',
	adminDocumentBuyerOrderNumber: 'Numero ordine acquirente',
	adminDocumentComission: 'Commissione',
	adminDocumentCustomerNumber: 'Numero cliente',
	adminDocumentCustomerPosition: 'Posizione cliente',
	adminDocumentCustomerSubPosition: 'Sottoposizione cliente',
	adminDocumentCommission: 'Commissione',
	adminDocumentDeliveryTime: 'Tempo di consegna',
	adminMenuDocument: 'Dati documento',
	adminMenuConfigurations: 'Configurazioni',
	adminMenuHistory: 'Storico',
	adminMenuConfiguration: 'Configurazione',
	adminMenuCalculation: 'Panoramica configurazione',
	adminMenuImages: 'Immagini',
	adminMenuSalesRemarks: 'Note di vendita',
	adminMenuInstallerRemarks: 'Note installatore',
	adminMenuPosition: 'Dati posizione',
	adminMenuDiscountsCosts: 'Sconti, Servizi, IVA',
	adminMenuTechnicalDocumentation: 'Documentazione tecnica',
	adminMenuPrintDocument: 'Stampa e invia',
	insideView: 'Vista interna',
	facade: 'Facciata',
	cartSuccess: "Cliccando sull'icona del carrello puoi modificarne il contenuto.",
	saving: 'Salvataggio',
	contactTitle: 'Dati contatto e accordi',
	contactTitleSales: 'Dati contatto',
	inquirySalesDialog: 'Documento',
	cart: 'Carrello',
	cartSendInquiry: 'Invia richiesta',
	cartRemove: 'Rimuovi',
	cartInquirySentText: ', grazie per la tua richiesta. La elaboreremo il prima possibile.',
	cartInquirySentText2: 'Grazie per la tua richiesta. La elaboreremo il prima possibile.',
	cartInquirySentText3: 'Documento creato',
	cartInquirySent: 'Richiesta inviata con successo',
	cartOverride: 'Vuoi sovrascrivere la configurazione esistente o crearne una nuova?',
	cartSaving: 'Salvataggio configurazione',
	cartSavingSuccess: 'La tua configurazione è stata aggiunta al carrello',
	documentSaving: 'Salvataggio documento',
	successfullySaved: 'Salvato con successo',
	cartButtonOverride: 'Sovrascrivi configurazione esistente',
	cartButtonNew: 'Crea nuova configurazione',
	cartRemoveTitle: 'Rimozione configurazione',
	cartRemovalText: 'Configurazione rimossa con successo',
	addDiscount: 'Sconto',
	addCost: 'Costo',
	addNetCost: 'Servizio',
	discountText: 'Nome',
	discountValue: 'Percentuale (%)',
	discountLevel: 'Livello',
	discountType: 'Tipo di sconto',
	discount: 'Percentuale',
	sortOrder: 'Ordine di ordinamento',
	discountAmount: 'Importo sconto',
	discountValueAfter: 'Valore dopo sconto',
	costText: 'Nome',
	costValue: 'Valore',
	requestDocumentation: 'Richiedi documentazione',
	requestSpecialDocumentation: 'Richiedi documentazione speciale',
	loadSpecialDocumentation: 'Carica documentazione speciale',
	user: 'Utente',
	image: 'Immagine',
	date: 'Data',
	customer: 'Cliente',
	partner: 'Partner',
	commission: 'Commissione',
	responsiblePerson: 'Persona responsabile',
	position: 'Posizione',
	value: 'Valore',
	dataLastChange: 'Data ultima modifica',
	documentation: 'Documentazione',
	inquiries: 'Richieste',
	offers: 'Offerte',
	printOffer: 'Stampa documento',
	printDownload: 'Scarica',
	printChangeToSend: 'Cambia in Inviato',
	printEditSent: 'Crea email',
	printEmailSubject: 'Varialis - {number}',
	printEmailBody:
		'Gentile Signore o Signora,\n\nIn base alla vostra richiesta, trovate in allegato il preventivo n. {number}.\n\nCordiali saluti,\nPortale VARIALIS\n\n\n\nAvviso: Le e-mail possono contenere informazioni riservate destinate solo al destinatario. Se il messaggio è stato inviato altrove per errore, si prega di informare l’autore. Se il messaggio non era destinato a voi, le informazioni non devono essere utilizzate, condivise, diffuse, copiate, stampate o sfruttate in alcun modo.',
	email: 'Email',
	password: 'Password',
	signIn: 'Accedi',
	signUp: 'Registrati',
	profile: 'Profilo',
	signingOut: 'Disconnessione',
	salesman: 'Venditore',
	salesmanResponsible: 'Venditore responsabile',
	signOut: 'Esci',
	submit: 'Invia',
	loginSuccess: '',
	loginError: 'Si è verificato un problema durante l’accesso.',
	addressing: 'Titolo',
	firstName: 'Nome',
	firstAndLastName: 'Nome e cognome',
	lastName: 'Cognome',
	loginFailed: 'Accesso non riuscito',
	loginNoPass: 'Inserisci la tua password',
	loginNoUsername: 'Inserisci la tua email',
	forgotPassword: 'Password dimenticata?',
	resetPassword: 'Reimposta la tua password',
	resetPasswordMessage: 'Email di conferma inviata, controlla la tua casella di posta per continuare.',
	registrationFailed: 'Registrazione non riuscita',
	missingFields: 'Inserisci tutti i campi obbligatori.',
	registrationSucceeded: 'Grazie per la registrazione. Hai ricevuto un’email con il link per completare il processo.',
	profileUpdateSucceeded: 'I dati del tuo profilo sono stati aggiornati.',
	profileOtherTitle: 'Vnesi ostale kontaktne podatke',
	profileDeliveryTitle: 'Indirizzo di consegna',
	profileReceiptTitle: 'Indirizzo di fatturazione',
	profileAddressAdd: 'Aggiungi indirizzo',
	profileAddressEdit: 'Modifica indirizzo',
	differentThenCompanyAddress: 'Inserisci le informazioni aziendali',
	differentThenContactAddress: 'Diverso dall’indirizzo di contatto',
	activationSucceeded: 'Attivazione riuscita',
	accountActivation: 'Attivazione account',
	confirmPassword: 'Conferma password',
	activate: 'Attiva',
	missingToken: 'Attivazione non valida. Registrati nuovamente.',
	telephone: 'Telefono',
	inquiryPartner: 'Partner',
	vat: 'Partita IVA',
	registrationNumber: 'Numero di registrazione',
	inquiryTitle:
		'Grazie per la tua richiesta. Per poterla elaborare, compila i dati di contatto, seleziona eventuali consensi (facoltativi) e invia la richiesta premendo il pulsante Invia.<br/>Con la presente acconsenti che la nostra azienda e i nostri partner commerciali ti contattino via e-mail e/o telefono utilizzando le informazioni fornite per soddisfare la tua richiesta, formulare un’offerta o fornire consulenza sui prodotti. In caso di ordine, acconsenti alla trasmissione dei tuoi dati a personale qualificato per consulenza e sopralluogo, al fine di evadere l’ordine.',
	inquiryTitleCustomer: 'Compila i dati di contatto del cliente',
	inquiryTitleExistingCustomer: 'Seleziona contatto esistente',
	inquiryDocumentType: 'Tipo di documento',
	address: 'Via e numero civico (Indirizzo)',
	city: 'Città',
	zip: 'CAP',
	post: 'Codice postale',
	country: 'Paese',
	selectCountry: 'Seleziona paese',
	selectDiscountType: 'Seleziona tipo di sconto',
	selectInquiryPartner: 'Scegli un partner',
	companyName: 'Nome società',
	companyRegistration: 'Numero di registrazione società',
	companyVAT: 'Partita IVA società',
	inquiryLegalAdd: 'Ulteriori dati per persone giuridiche',
	inquiryConsents: 'Consensi',
	inquiryConsent1Title: 'Offerte e promemoria',
	inquiryConsent1: 'es. informazioni su offerte di prodotti, ricambi, accessori e altri servizi.',
	inquiryConsent2Title: 'Notifiche',
	inquiryConsent2: 'annunci e inviti a eventi per il lancio di nuovi modelli e cataloghi, fiere, open day, presentazioni e altri eventi.',
	inquiryConsent3Title: 'Sondaggi',
	inquiryConsent3: 'ricerche per raccogliere la tua opinione e migliorare i nostri prodotti e servizi.',
	equalPasswords: 'Inserisci password uguali',
	type: 'Tipo',
	brands: 'Marchi',
	partners: 'Partner',
	delete: 'Elimina',
	languages: 'Lingue',
	clearCache: 'Cancella cache',
	tags: 'Trova etichetta',
	text: 'Testo',
	desc: 'Descrizione',
	configuration: 'Configurazione',
	document: 'Documento',
	edit: 'Modifica',
	change: 'Cambia',
	view: 'Visualizza',
	clone: 'Elemento',
	copy: 'Copia',
	remove: 'Rimuovi',
	default: 'Predefinito',
	add: 'Aggiungi',
	deleting: 'Eliminazione...',
	adding: 'Aggiunta...',
	cloning: 'Clonazione...',
	print: 'Stampa',
	submitForProduction: 'Invia in produzione',
	cartAddingDisabled:
		'Hai raggiunto il limite di progetti salvati. Effettua il login per un numero illimitato di progetti.\nPer registrarti o accedere, clicca sull’icona in alto a destra.',
	notSucceeded: 'fallito',
	documentType: 'Tipo di documento',
	printPrice: 'Prezzi',
	printColorImage: 'Immagine a colori',
	printTechImage: 'Disegno tecnico',
	printConditions: 'Termini di pagamento e consegna',
	selectPrintTemplate: 'Seleziona modello',
	selectPrintLanguage: 'Seleziona lingua',
	sendToConfirmation: 'Invia per conferma',
	inConfirmation: 'In conferma',
	isFinished: 'Completato',
	confirm: 'Conferma',
	reject: 'Rifiuta',
	reset: 'Reimposta',
	downloadPriceFile: 'Scarica xlsx',
	termsPayment: 'Termini di pagamento',
	termsSales: 'Termini di vendita',
	addTermPayment: 'Aggiungi termine di pagamento',
	addTermSales: 'Aggiungi termine di consegna',
	editTermPayment: 'Modifica termine di pagamento',
	editTermSales: 'Modifica termine di consegna',
	viewTermPayment: 'Visualizza termine di pagamento',
	viewTermSales: 'Visualizza termine di consegna',
	term: 'Termine',
	termsPage: 'Termini di pagamento e consegna',
	send: 'Invia',
	confirmDelete: 'Sei sicuro di voler eliminare il record selezionato?',
	confirmArchive: 'Sei sicuro di voler archiviare il record selezionato?',
	confirmReset: 'Sei sicuro di voler reimpostare la configurazione selezionata ai valori predefiniti?',
	confirmClone: 'Sei sicuro di voler clonare il record selezionato?',
	confirmCopy: 'Sei sicuro di voler copiare il record selezionato?',
	confirmChangeStatusToSend: 'Sei sicuro di voler cambiare lo stato del documento in Inviato?',
	confirmChangeStatusSpecialTechnical:
		'Attenzione! Ripetendo la richiesta per la documentazione tecnica, la documentazione speciale preparata verrà persa.',
	confirmRequestDocumentation: 'Attenzione! Ripetendo la richiesta per la documentazione tecnica, la documentazione speciale preparata verrà persa.',
	confirmSend: 'Sei sicuro di voler inviare il documento?',
	confirmSendDocument:
		'Il destinatario del documento è:<br/>- Partner: {Partner}<br/>- Venditore: {Salesman}<br/>- Contatto: {Contact}<br/><br/> Sei sicuro di voler inviare il documento?',
	changeRecipient: 'Cambia destinatario',
	totalPriceWithoutTax: 'Prezzo totale senza IVA',
	totalTax: 'IVA totale',
	finalPrice: 'Prezzo totale con IVA',
	selectTax: 'Seleziona tassazione',
	tax: 'IVA',
	printTemplateSelect: 'Il documento dovrebbe includere:',
	userUploaded: 'Caricato dall’utente',
	yes: 'Sì',
	no: 'No',
	contact: 'Contatto',
	autoSaveConfiguration: 'Le modifiche vengono salvate automaticamente',
	loginToViewPrices: 'Accedi per visualizzare i prezzi',
	cookieLaw:
		'Il sito web utilizza i cookie per garantirne la piena funzionalità. I cookie memorizzano il tuo utilizzo del sito. Utilizzando il sito, autorizzi l’uso di questi cookie. Visita per maggiori informazioni:',
	cookiesTitle: 'Informazioni sull’uso dei cookie',
	details: 'Dettagli',
	sourceDocument: 'Documento di origine',
	download: 'Scarica',
	downloadPDF: 'Scarica PDF',
	clonePart: 'Elemento',
	languageChange: 'Cambio lingua',
	languageChangeConfirm:
		'Cambiando lingua verrai reindirizzato alla schermata iniziale. Le modifiche non salvate alla configurazione verranno ignorate.',
	brandChange: 'Cambio marca',
	brandChangeConfirm: 'Cambiando marca verrai reindirizzato alla schermata iniziale. Le modifiche non salvate alla configurazione verranno ignorate.',
	specialOffer: 'Offerta speciale',
	archive: 'Archivio',
	includeArchived: 'Mostra documenti archiviati',
	showAll: 'Mostra tutto',
	cartEmpty: 'Nessun articolo nel carrello',
	clipboard: 'Copiato negli appunti',
	inputText: 'Inserisci testo',
	inputNumber: 'Inserisci un numero',
	twoDecimalPlaces: 'due cifre decimali',
	treeDetails: 'Elenco parametri',
	deliveryTime: 'Consegna',
	viewChangeTitle: 'Cambia vista',
	viewChangeDescription:
		'Dopo la conferma verrai reindirizzato alla vista desiderata. Le modifiche non salvate alla configurazione verranno ignorate.',
};
export default locale;
